
import { Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import Design from "@/components/common/Design.vue"
import Toolbar from "@/components/common/Toolbar.vue"
import Preview from "@/components/common/Preview.vue"
import TreasureBookDesign from "@/components/products/schatzbuch/design/TreasureBookDesign.vue"
import GiftOptionsButton from "@/components/common/GiftOptionsButton.vue"
import { TreasureBookModule } from '@/store/modules/treasureBook'

@Component({
  name: "design",
  components: {
    Toolbar,
    Preview,
    GiftOptionsButton,
    TreasureBookDesign
  }
})
export default class DesignImpl extends Design {
  get showToolbar(): boolean {
    return TreasureBookModule.showToolbar;
  }
  get activeComponent():string {
    return "treasure-book-design"
  }

  get allowPreview(): boolean {
    return true
  }
}
